import { render, staticRenderFns } from "./TicketCustomerDetail.vue?vue&type=template&id=e327bf16&scoped=true"
import script from "./TicketCustomerDetail.vue?vue&type=script&lang=js"
export * from "./TicketCustomerDetail.vue?vue&type=script&lang=js"
import style0 from "./TicketCustomerDetail.vue?vue&type=style&index=0&id=e327bf16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e327bf16",
  null
  
)

export default component.exports